import { ListFilters } from './list-filters';
import { VocTerm } from './voc-term';
import { DateRange } from './date-range';
import { NameElement } from './name-list';

export class BibListFilters extends ListFilters {
    private _author: string;
    private _title: string;
    private _date: DateRange;
    private _content: string;
    private _quotation_label: string;

    constructor() {
        super();
        this.init();
    }

    init(): void {
        this._author = null;
        this._title = null;
        this._date = {from: null, to: null};
        this._content = null;
    }

    reset(): void {
        this.initAllFilters(); // super class initialization
        this.init();
    }

    /* Author/Editor filter */
    set author(value: string) {
        if (value) {
            this._author = value;
            this.addMatchFilter('__biblioAuthor', this._author);
        } else {
            this._author = null;
            this.removeMatchFilter('__biblioAuthor');
        }
    }

    get author(): string {
        return this._author;
    }

    /* Title filter */
    set title(value: string) {
        if (value) {
            this._title = value;
            this.addMatchFilter('title', '%' + this._title + '%');
        } else {
            this._title = null;
            this.removeMatchFilter('title');
        }
    }

    get title(): string {
        return this._title;
    }

    /* Date filter */
    set date(value: DateRange) {
        if (value) {
            this._date = value;
            if (this._date.from) {
                this.addRangeFilter('data_edition_date_from', 'gte', this._date.from);
            } else {
                this.removeRangeFilter('data_edition_date_from');
            }
            if (this._date.to) {
                this.addRangeFilter('data_edition_date_to', 'lte', this._date.to);
            } else {
                this.removeRangeFilter('data_edition_date_to');
            }
        } else {
            this._date = {from: null, to: null};
            this.removeRangeFilter('data_edition_date_from');
            this.removeRangeFilter('data_edition_date_to');
        }
    }

    get date(): DateRange {
        return this._date;
    }

    /* Content filter */
    set content(value: string) {
        if (value) {
            this._content = value;
            this.addMatchFilter('__biblioContent', this._content);
        } else {
            this._content = null;
            this.removeMatchFilter('__biblioContent');
        }
    }

    get content(): string {
        return this._content;
    }

    /* Quotation label */
    set quotation_label(value: string) {
        if (value) {
            this._quotation_label = value;
            this.addMatchFilter('quotation_label', '%' + this._quotation_label + '%');
        } else {
            this._quotation_label = null;
            this.removeMatchFilter('quotation_label');
        }
    }

    get quotation_label(): string {
        return this._quotation_label;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/bib-list-filters.ts